import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import Slide from '@material-ui/core/Slide'
import Betslip from './Betslip'

const DialogBase = styled(Dialog)`
  .MuiDialog-paperFullScreen {
    background-color: ${props => props.theme.palette.background.default};
  }
`

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

const FullScreenDialog = props => {
  const { handleClose, open } = props

  return (
    <DialogBase
      fullScreen
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
    >
      <AppBar style={{ position: 'relative' }} onClick={handleClose}>
        <Toolbar>
          <IconButton
            edge="end"
            color="inherit"
            aria-label="close"
            style={{ marginLeft: `auto` }}
          >
            <KeyboardArrowDownIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      <Betslip view="Mobile" />
    </DialogBase>
  )
}

FullScreenDialog.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
}

export default FullScreenDialog
